import { createEffect } from 'effector'
import { onError } from '@/app/routing/events'
import { getAppStatus, getFarcanaAuthLink, getFarcanaStats } from '../api'
import { FarcanaAuthResponse, FarcanaStatsResponse } from '../types'

export const getFarcanaAuthLinkFx = createEffect(async (token: string): Promise<FarcanaAuthResponse> => {
  const data = await getFarcanaAuthLink(token)
  return data
})
getFarcanaAuthLinkFx.failData.watch(() => {
  onError()
})

export const getFarcanaStatsFx = createEffect(async (token: string): Promise<FarcanaStatsResponse> => {
  const data = await getFarcanaStats(token)
  return data
})
getFarcanaStatsFx.failData.watch(() => {
  onError()
})

export const getAppStatusFx = createEffect(async (token: string) => {
  const data = await getAppStatus(token)
  return data
})
